// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderDescripton_description__MiQTC {
  padding: 16px;
}
.OrderDescripton_description--is-loading__cS6S8 {
  height: 200px;
  border-radius: 8px;
  margin-top: 12px;
  margin-left: 12px;
  margin-right: 12px;
}
@media (min-width: 1200px) {
  .OrderDescripton_description__MiQTC {
    padding: 12px;
  }
}

.OrderDescripton_list__irCaZ {
  list-style-type: none;
  padding: 0;
}

.OrderDescripton_row__Un5De {
  margin-bottom: 8px;
  border-bottom: 1px solid #F3F2F2;
  padding-bottom: 8px;
}
.OrderDescripton_row__Un5De:last-child {
  margin-bottom: 0;
}
@media (min-width: 1200px) {
  .OrderDescripton_row__Un5De {
    border-bottom: none;
    padding-bottom: 0;
  }
}

.OrderDescripton_rowTitle__v9Rvq {
  font-size: var(--fz-sm);
  font-weight: 400;
  line-height: 114%;
  color: #54575C;
}
@media (min-width: 1200px) {
  .OrderDescripton_rowTitle__v9Rvq {
    font-size: var(--fz-xs);
    line-height: 12px;
    font-weight: 500;
  }
}

.OrderDescripton_rowTxt__ZxLuB {
  font-size: var(--fz-lg);
  font-weight: 400;
  line-height: 144%;
}
@media (min-width: 1200px) {
  .OrderDescripton_rowTxt__ZxLuB {
    font-size: var(--fz-sm);
    line-height: var(--lh-sm);
  }
}

.OrderDescripton_assignee__P6A9O {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  gap: 8px;
}
.OrderDescripton_assignee__avatar__4I6qA {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
}
.OrderDescripton_assignee__name__XVkXR {
  font-size: var(--fz-sm);
  line-height: var(--lh-sm);
  color: #54575C;
}

.OrderDescripton_information-row__mo2n6 {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}
.OrderDescripton_information-row__mo2n6 p {
  font-size: var(--fz-sm);
  font-weight: 400;
  line-height: 114%;
  color: #54575C;
}
@media (min-width: 1200px) {
  .OrderDescripton_information-row__mo2n6 p {
    font-size: var(--fz-xs);
    line-height: 12px;
    font-weight: 500;
  }
}
.OrderDescripton_information-row__mo2n6 h5 {
  margin-bottom: 4px;
  font-size: var(--fz-lg);
  font-weight: 400;
  line-height: 144%;
}
@media (min-width: 1200px) {
  .OrderDescripton_information-row__mo2n6 h5 {
    font-size: var(--fz-md);
    font-weight: 600;
    line-height: 114%;
  }
}
.OrderDescripton_information-row__content__LhX7d {
  display: flex;
  flex-direction: column;
}
.OrderDescripton_information-row__content__LhX7d .OrderDescripton_info-text__d-0Jo * {
  font-size: var(--fz-md);
  line-height: var(--lh-sm);
  font-weight: initial;
  margin-bottom: 8px;
}
@media (min-width: 1200px) {
  .OrderDescripton_information-row__content__LhX7d .OrderDescripton_info-text__d-0Jo * {
    font-size: var(--fz-sm);
  }
}
.OrderDescripton_information-row__content__LhX7d .OrderDescripton_info-text__d-0Jo img {
  max-width: 100%;
}
.OrderDescripton_information-row__content__LhX7d .OrderDescripton_info-text__d-0Jo ul, .OrderDescripton_information-row__content__LhX7d .OrderDescripton_info-text__d-0Jo ol {
  padding-inline-start: 30px;
}

.OrderDescripton_photo-block__\\+\\+gYp {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 8px;
}
@media (min-width: 640px) {
  .OrderDescripton_photo-block__\\+\\+gYp {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 1200px) {
  .OrderDescripton_photo-block__\\+\\+gYp {
    grid-template-columns: 1fr 1fr;
  }
}
.OrderDescripton_photo-block__preview__FfvOO {
  height: 105px;
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.OrderDescripton_photo-block__preview__FfvOO > img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
@media (min-width: 640px) {
  .OrderDescripton_photo-block__preview__FfvOO {
    height: 140px;
  }
}
@media (min-width: 1200px) {
  .OrderDescripton_photo-block__preview__FfvOO {
    height: 80px;
  }
}

.OrderDescripton_file-block__rfXz5 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.OrderDescripton_file-block__rfXz5 .OrderDescripton_file-row__Hd64- {
  display: flex;
  gap: 10px;
  width: max-content;
}
.OrderDescripton_file-block__rfXz5 .OrderDescripton_file-row__text__vBJw3 {
  font-size: var(--fz-lg);
}
@media (min-width: 1200px) {
  .OrderDescripton_file-block__rfXz5 .OrderDescripton_file-row__Hd64- {
    width: auto;
  }
  .OrderDescripton_file-block__rfXz5 .OrderDescripton_file-row__text__vBJw3 {
    font-size: var(--fz-sm);
  }
}

.OrderDescripton_order-descr-accord__b4kiF {
  padding-right: 4px;
}
.OrderDescripton_coordinators-container__teiwF {
  margin-top: 16px;
}
.OrderDescripton_coordinators-container__teiwF h4 {
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.OrderDescripton_coordination-accordion__IQI1s {
  margin-top: 16px;
}

.OrderDescripton_order-descr-container__94QLC {
  position: relative;
}
.OrderDescripton_order-descr-container__94QLC .OrderDescripton_canceled__Pi6IP {
  position: absolute;
  top: -20px;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/OrderDescription/OrderDescripton.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AAEE;EAXF;IAYI,aAAA;EACF;AACF;;AAEA;EACE,qBAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;AACF;AACE;EACE,gBAAA;AACJ;AAEE;EATF;IAUI,mBAAA;IACA,iBAAA;EACF;AACF;;AAEA;EACE,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AACF;AACE;EANF;IAOI,uBAAA;IACA,iBAAA;IACA,gBAAA;EAEF;AACF;;AACA;EACE,uBAAA;EACA,gBAAA;EACA,iBAAA;AAEF;AAAE;EALF;IAMI,uBAAA;IACA,yBAAA;EAGF;AACF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,QAAA;AAGF;AADE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;AAGJ;AAAE;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;AAEJ;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AACF;AACE;EACE,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AACJ;AACI;EANF;IAOI,uBAAA;IACA,iBAAA;IACA,gBAAA;EAEJ;AACF;AACE;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AACJ;AACI;EANF;IAOI,uBAAA;IACA,gBAAA;IACA,iBAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,sBAAA;AACJ;AAEM;EACE,uBAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;AAAR;AAEQ;EANF;IAOI,uBAAA;EACR;AACF;AAEM;EACE,eAAA;AAAR;AAGM;EACE,0BAAA;AADR;;AAOA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;AAJF;AAME;EANF;IAOI,qCAAA;EAHF;AACF;AAKE;EAVF;IAWI,8BAAA;EAFF;AACF;AAIE;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAFJ;AAII;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAFN;AAOI;EADF;IAEI,aAAA;EAJJ;AACF;AAMI;EALF;IAMI,YAAA;EAHJ;AACF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAJF;AAME;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AAJJ;AAMI;EACE,uBAAA;AAJN;AAOI;EATF;IAUI,WAAA;EAJJ;EAMI;IACE,uBAAA;EAJN;AACF;;AASA;EACE,kBAAA;AANF;AAeA;EACE,gBAAA;AAbF;AAeE;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAbJ;;AAiBA;EACE,gBAAA;AAdF;;AAiBA;EACE,kBAAA;AAdF;AAgBE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAdJ","sourcesContent":[".description {\r\n  padding: 16px;\r\n\r\n  &--is-loading {\r\n    height: 200px;\r\n    border-radius: 8px;\r\n    margin-top: 12px;\r\n    margin-left: 12px;\r\n    margin-right: 12px;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    padding: 12px;\r\n  }\r\n}\r\n\r\n.list {\r\n  list-style-type: none;\r\n  padding: 0;\r\n}\r\n\r\n.row {\r\n  margin-bottom: 8px;\r\n  border-bottom: 1px solid #F3F2F2;\r\n  padding-bottom: 8px;\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    border-bottom: none;\r\n    padding-bottom: 0;\r\n  }\r\n}\r\n\r\n.rowTitle {\r\n  font-size: var(--fz-sm);\r\n  font-weight: 400;\r\n  line-height: 114%;\r\n  color: #54575C;\r\n\r\n  @media(min-width: 1200px) {\r\n    font-size: var(--fz-xs);\r\n    line-height: 12px;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n.rowTxt {\r\n  font-size: var(--fz-lg);\r\n  font-weight: 400;\r\n  line-height: 144%;\r\n\r\n  @media(min-width: 1200px) {\r\n    font-size: var(--fz-sm);\r\n    line-height: var(--lh-sm);\r\n  }\r\n}\r\n\r\n.assignee {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 8px;\r\n  gap: 8px;\r\n\r\n  &__avatar {\r\n    flex-shrink: 0;\r\n    width: 38px;\r\n    height: 38px;\r\n    border-radius: 50%;\r\n    object-fit: cover;\r\n    object-position: center;\r\n  }\r\n\r\n  &__name {\r\n    font-size: var(--fz-sm);\r\n    line-height: var(--lh-sm);\r\n    color: #54575C;\r\n  }\r\n}\r\n\r\n.information-row {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 8px;\r\n\r\n  p {\r\n    font-size: var(--fz-sm);\r\n    font-weight: 400;\r\n    line-height: 114%;\r\n    color: #54575C;\r\n  \r\n    @media(min-width: 1200px) {\r\n      font-size: var(--fz-xs);\r\n      line-height: 12px;\r\n      font-weight: 500;\r\n    }\r\n  }\r\n\r\n  h5 {\r\n    margin-bottom: 4px;\r\n    font-size: var(--fz-lg);\r\n    font-weight: 400;\r\n    line-height: 144%;\r\n    \r\n    @media (min-width: 1200px) {\r\n      font-size: var(--fz-md);\r\n      font-weight: 600;\r\n      line-height: 114%;\r\n    }\r\n  }\r\n\r\n  &__content {\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    .info-text {\r\n      * {\r\n        font-size: var(--fz-md);\r\n        line-height: var(--lh-sm);\r\n        font-weight: initial;\r\n        margin-bottom: 8px;\r\n\r\n        @media (min-width: 1200px) {\r\n          font-size: var(--fz-sm);\r\n        }\r\n      }\r\n\r\n      img {\r\n        max-width: 100%;\r\n      }\r\n\r\n      ul, ol {\r\n        padding-inline-start: 30px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.photo-block {\r\n  display: grid;\r\n  grid-gap: 8px;\r\n  grid-template-columns: 1fr 1fr;\r\n  margin-bottom: 8px;\r\n\r\n  @media (min-width: 640px) {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  &__preview {\r\n    height: 105px;\r\n    border-radius: 8px;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    overflow: hidden;\r\n\r\n    &>img {\r\n      width: 100%;\r\n      height: 100%;\r\n      object-fit: contain;\r\n      object-position: center;\r\n    }\r\n  }\r\n\r\n  &__preview {\r\n    @media (min-width: 640px) {\r\n      height: 140px;\r\n    }\r\n\r\n    @media (min-width: 1200px) {\r\n      height: 80px;\r\n    }\r\n  }\r\n}\r\n\r\n.file-block {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n\r\n  .file-row {\r\n    display: flex;\r\n    gap: 10px;\r\n    width: max-content;\r\n\r\n    &__text {\r\n      font-size: var(--fz-lg);\r\n    }\r\n\r\n    @media (min-width: 1200px) {\r\n      width: auto;\r\n\r\n      &__text {\r\n        font-size: var(--fz-sm);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.order-descr-accord {\r\n  padding-right: 4px;\r\n\r\n  :global {\r\n    .accordion-main {\r\n      // max-height: 500px;\r\n    }\r\n  }\r\n}\r\n\r\n.coordinators-container {\r\n  margin-top: 16px;\r\n\r\n  h4 {\r\n    margin-bottom: 8px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n.coordination-accordion {\r\n  margin-top: 16px;\r\n}\r\n\r\n.order-descr-container {\r\n  position: relative;\r\n\r\n  .canceled {\r\n    position: absolute;\r\n    top: -20px;\r\n    right: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `OrderDescripton_description__MiQTC`,
	"description--is-loading": `OrderDescripton_description--is-loading__cS6S8`,
	"list": `OrderDescripton_list__irCaZ`,
	"row": `OrderDescripton_row__Un5De`,
	"rowTitle": `OrderDescripton_rowTitle__v9Rvq`,
	"rowTxt": `OrderDescripton_rowTxt__ZxLuB`,
	"assignee": `OrderDescripton_assignee__P6A9O`,
	"assignee__avatar": `OrderDescripton_assignee__avatar__4I6qA`,
	"assignee__name": `OrderDescripton_assignee__name__XVkXR`,
	"information-row": `OrderDescripton_information-row__mo2n6`,
	"information-row__content": `OrderDescripton_information-row__content__LhX7d`,
	"info-text": `OrderDescripton_info-text__d-0Jo`,
	"photo-block": `OrderDescripton_photo-block__++gYp`,
	"photo-block__preview": `OrderDescripton_photo-block__preview__FfvOO`,
	"file-block": `OrderDescripton_file-block__rfXz5`,
	"file-row": `OrderDescripton_file-row__Hd64-`,
	"file-row__text": `OrderDescripton_file-row__text__vBJw3`,
	"order-descr-accord": `OrderDescripton_order-descr-accord__b4kiF`,
	"coordinators-container": `OrderDescripton_coordinators-container__teiwF`,
	"coordination-accordion": `OrderDescripton_coordination-accordion__IQI1s`,
	"order-descr-container": `OrderDescripton_order-descr-container__94QLC`,
	"canceled": `OrderDescripton_canceled__Pi6IP`
};
export default ___CSS_LOADER_EXPORT___;
